import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import arrowIcon from "../../../assets/images/Vector_btn.png";

export default function Documenti({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  const onShare = (popupId) => {
    const url = new URL(window.location.href);
    url.searchParams.set("popup", popupId);

    if (navigator.share) {
      navigator
        .share({ title: "Sustainability documents", url: url.toString() })
        .catch(() => {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(url.toString()).catch(() => {});
    }
  };

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

 // 1) Sostituisci l'array docs con:
const docs = [
  {
    label: "Integrated Consolidated Financial Statements",
    href: "https://www.realegroup.eu/groupshare/0/EN/ListaReportsAndAccounts/64/Reale%20Group_Integrated%20Consolidated%20Financial%20Statement%202025.pdf",
  },
  {
    label: "Sustainability Statement\nExecutive Summary",
    href: "https://www.realegroup.eu/groupshare/0/EN/ListaSustainabilityReports/37/EXECUTIVE%20SUMMARY%202025_EN.pdf",
  },
  {
    label: "Impact Report Benefit Corporation",
    href: "https://www.realegroup.eu/groupshare/0/EN/ListaReportsAndAccounts/65/Relazione%20di%20Impatto%202025%20ENG.pdf",
  },
  {
    label: "PSI Disclosure of Progress",
    href: "https://www.realegroup.eu/groupshare/0/EN/Documents/Istituzionale/Sostenibilita/RELAZIONE%20PSI%202025%20def.pdf",
  },
  {
    label: "Group Environmental Guidelines",
    href: "https://www.realegroup.eu/groupshare/0/EN/Documents/Istituzionale/Sostenibilita/Linee%20Guida%20Ambientali%20ENG.pdf",
  },
  {
    label: "Reale Group ISO 14001 Certification",
    href: "https://www.realegroup.eu/groupshare/0/IT/Documents/Sostenibilit%C3%A0/CertificatoRINA2024-2027.pdf",
  },
  {
    label: "Code of Ethics",
    href: "https://www.realegroup.eu/groupshare/0/EN/Documents/Istituzionale/Sostenibilita/Code%20of%20Ethics%202024.pdf",
  },
  {
    label: "Gender Equality Policies",
    href: "https://bilanci.realegroup.eu/en/gender-equality",
  },
  
];


  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[1400] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Sustainability documents"
    >
      <div
        className="relative w-full md:w-[1280px] bg-white max-h-[90vh] overflow-y-auto overscroll-contain"
        style={{ background: "#E7E3DF", WebkitOverflowScrolling: "touch" }}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-3 z-10 flex items-center gap-2 justify-end pr-3">
          <button
            onClick={() => onShare("Documenti")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Condividi"
            aria-label="Condividi"
          >
            <img src={shareIcon} alt="" className="h-4 w-4" />
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/90 border border-[#0E3761]/30 hover:bg-white transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <img src={closeIcon} alt="Chiudi" className="h-4 w-4" />
          </button>
        </div>

        {/* Content */}
        <div className="p-8">
          <h2 className="text-[#004996] text-[30px] md:text-[40px] font-bold">
            Sustainability documents
          </h2>

          {/* Grid: 1 col mobile, 2 col desktop */}
          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8 justify-items-center">
            {docs.map(({ label, href }, i) => (
              <a
                key={i}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  group
                  inline-flex items-center gap-3 w-[350px] max-w-full
                  min-h-[60px] px-6
                  rounded-full border-2
                  border-[#0E3761] text-[#0E3761]
                  hover:bg-[#0E3761] hover:text-white
                  transition-colors
                "
                title={label.replace(/\n/g, " ")}
              >
                <img
                  src={arrowIcon}
                  alt=""
                  className="w-[25px] h-[25px] transition"
                />
                <span className="whitespace-pre-line text-left font-bold">
                  {label}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
